import React, { useId } from 'react';
import { Circle, Rect } from 'react-native-svg';
import { Icon, IconWithGradient } from 'design-system/icons/Icon';
import useColors from 'hooks/useColors';
export const IconRadio = ({ selected = false, ...props }) => {
    const colors = useColors();
    const id = useId();
    if (selected) {
        return (<IconWithGradient id={id} {...props} defaultGradientKey="ultimate">
        <Rect width="24" height="24" rx="12" fill={`url(#gradient_${id})`}/>
        <Circle cx="12" cy="12" r="6" fill={colors.elements.white}/>
      </IconWithGradient>);
    }
    return (<Icon {...props}>
      <Rect width="24" height="24" rx="12" fill={colors.cards.onLight}/>
      <Rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke={colors.borders.logoStroke}/>
    </Icon>);
};
export default IconRadio;
